import { useState, useCallback } from 'react';
import { useInjection } from '../../../di_container/InjectionProvider';
import { Job } from '../../firestore_model';
import { pagination } from '../../../common/constants/Constants';
import { JobOffer } from '../../firestore_model/job';
export const useJobOfferDetail = () => {
    const { container } = useInjection();
    const [loadingReviewList, setLoadingReviewList] = useState(false);
    const [loadingAppliedList, setLoadingAppliedList] = useState(false);
    const [loadingCheckInList, setLoadingCheckInList] = useState(false);
    const [loadingApproval, setLoadingApproval] = useState(false);
    const [loadingPostReview, setLoadingPostReview] = useState(false);
    // レビュー一覧
    const loadReviewList = useCallback(async (jobClinic, jobOfferId, lastDocument) => {
        setLoadingReviewList(true);
        try {
            const { collectionReference } = jobClinic.jobOffers;
            const path = new JobOffer(collectionReference.doc(jobOfferId)).reviewPosts.collectionReference.path;
            const firestoreRepository = container.resolve('FirestoreRepository');
            const result = await firestoreRepository.loadDocuments({
                path,
                isGroup: false,
                limit: pagination.limit,
                startAfter: lastDocument,
                orderBy: {
                    fieldPath: 'createdAt',
                    directionStr: 'desc',
                },
            });
            setLoadingReviewList(false);
            return {
                data: result.docs.map((item) => Job.ReviewPost.fromSnapshot(item)),
                lastDocument: result.lastDocument,
            };
        }
        catch (e) {
            setLoadingReviewList(false);
            throw e;
        }
    }, []);
    // 応募ユーザー一覧
    const loadAppliedList = useCallback(async (jobClinic, jobOfferId, lastDocument) => {
        setLoadingAppliedList(true);
        try {
            const { collectionReference } = jobClinic.jobOffers;
            const path = new JobOffer(collectionReference.doc(jobOfferId)).jobsApplied.collectionReference.path;
            const firestoreRepository = container.resolve('FirestoreRepository');
            const result = await firestoreRepository.loadDocuments({
                path,
                isGroup: false,
                limit: pagination.limit,
                startAfter: lastDocument,
                orderBy: {
                    fieldPath: 'createdAt',
                    directionStr: 'desc',
                },
            });
            setLoadingAppliedList(false);
            return {
                data: result.docs.map((item) => Job.JobApplied.fromSnapshot(item)),
                lastDocument: result.lastDocument,
            };
        }
        catch (e) {
            setLoadingAppliedList(false);
            throw e;
        }
    }, []);
    // チェックイン一覧
    const loadCheckInList = useCallback(async (jobClinic, jobOfferId, lastDocument) => {
        setLoadingCheckInList(true);
        try {
            const firestoreRepository = container.resolve('FirestoreRepository');
            const result = await firestoreRepository.loadDocuments({
                path: jobClinic.jobCheckIns.collectionReference.path,
                isGroup: false,
                whereList: [{ fieldPath: 'jobOfferId', opStr: '==', value: jobOfferId }],
                limit: pagination.limit,
                startAfter: lastDocument,
                orderBy: {
                    fieldPath: 'createdAt',
                    directionStr: 'desc',
                },
            });
            setLoadingCheckInList(false);
            return {
                data: result.docs.map((item) => Job.JobCheckIn.fromSnapshot(item)),
                lastDocument: result.lastDocument,
            };
        }
        catch (e) {
            setLoadingCheckInList(false);
            throw e;
        }
    }, []);
    const approvalJobApplied = useCallback(async (workerId, jobOfferId, isApprove) => {
        setLoadingApproval(true);
        try {
            const imoryApiRepository = container.resolve('ImoryApiRepository');
            await imoryApiRepository.approvalJobApplied(workerId, jobOfferId, isApprove);
            setLoadingApproval(false);
        }
        catch (e) {
            setLoadingApproval(false);
            throw e;
        }
    }, []);
    const postReview = useCallback(async (rating, text, jobOfferId, workerId) => {
        setLoadingPostReview(true);
        try {
            const imoryApiRepository = container.resolve('ImoryApiRepository');
            await imoryApiRepository.postReviewFromClinic(rating, text, jobOfferId, workerId);
            setLoadingPostReview(false);
        }
        catch (e) {
            setLoadingPostReview(false);
            throw e;
        }
    }, []);
    return {
        loadingReviewList,
        loadingAppliedList,
        loadingCheckInList,
        loadingApproval,
        loadingPostReview,
        loadReviewList,
        loadAppliedList,
        loadCheckInList,
        approvalJobApplied,
        postReview,
    };
};
